import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Dashboard',
        icon: 'ph-house-line',
        link: '/dashboard',
    },
    {
        id: 2,
        label: 'employees',
        icon: 'ph-users',
        subItems: [
            {
                id: 3,
                label: 'employeesList',
                link: '/employees/employees-list',
                parentId: 2
            },
            {
                id: 31,
                label: 'newemployeesList',
                link: '/employees/new-employees-list',
                parentId: 2
            },
            {
                id: 30,
                label: 'contractsList',
                link: '/employees/contracts-list',
                parentId: 2
            },
            {
                id: 4,
                label: 'shifts',
                link: '/employees/shifts-list',
                parentId: 2
            },
            // {
            //     id: 5,
            //     label: 'attendance',
            //     link: '/employees/attendance',
            //     parentId: 2
            // },
            {
                id: 6,
                label: 'absenceReasons',
                link: '/employees/absence-reasons',
                parentId: 2
            },
            // {
            //     id: 7,
            //     label: 'employeesTransferRequests',
            //     link: '/employees/transfer-requests',
            //     parentId: 2
            // },
            {
                id: 8,
                label: 'followup',
                link: '/employees/followup',
                parentId: 2
            },
            {
                id: 28,
                label: 'vacations',
                link: '/employees/vacations',
                parentId: 2
            },
            {
                id: 29,
                label: 'vecation-requests',
                link: '/employees/vecation-requests',
                parentId: 2
            },
            {
                id: 32,
                label: 'employees-transfer-requests',
                link: '/employees/employees-transfer-requests',
                parentId: 2
            },
            {
                id: 33,
                label: 'teams-transfer-requests',
                link: '/employees/teams-transfer-requests',
                parentId: 2
            },
            {
                id: 37,
                label: 'direct-work-newemployees-requests',
                link: '/employees/direct-work-newemployees-requests',
                parentId: 2
            },
            {
                id: 38,
                label: 'direct-work-vacations-requests',
                link: '/employees/direct-work-vacations-requests',
                parentId: 2
            },
        ]
    },
    {
        id: 9,
        label: 'equipments',
        icon: 'ph-wrench',
        subItems: [
            {
                id: 10,
                label: 'equipmentsList',
                link: '/equipments/equipments-list',
                parentId: 9
            },
            {
                id: 39,
                label: 'newEquipmentsList',
                link: '/equipments/new-equipments-list',
                parentId: 9
            },
            // {
            //     id: 11,
            //     label: 'equipmentspreparation',
            //     link: '/equipments/preparation',
            //     parentId: 9
            // },
            // {
            //     id: 11,
            //     label: 'equipmentstracking',
            //     link: '/equipments/tracking',
            //     parentId: 9
            // },
            {
                id: 11,
                label: 'equipmentsTransferRequests',
                link: '/equipments/transfer-requests',
                parentId: 9
            },
            {
                id: 40,
                label: 'dieselConsumption',
                link: '/equipments/diesel-consumption',
                parentId: 9
            },
            {
                id: 41,
                label: 'malfunctionRequests',
                link: '/equipments/malfunction-requests',
                parentId: 9
            },
            {
                id: 42,
                label: 'driversRequests',
                link: '/equipments/drivers-requests',
                parentId: 9
            },
        ]
    },
    {
        id: 12,
        label: 'projects',
        icon: 'ph-cube',
        link: '/projects/projects-list',
    },
    {
        id: 13,
        label: 'locations',
        icon: 'ph-map-pin',
        link: '/locations/locations-list',
    },
    {
        id: 14,
        label: 'teams',
        icon: 'ph-puzzle-piece',
        link: '/teams/teams-list',
    },
    {
        id: 34,
        label: 'Approvals',
        icon: 'ph-thumbs-up',
        subItems: [
            {
                id: 35,
                label: 'ApprovalsTypes',
                link: '/approvals/approval-types',
                parentId: 34
            },
            {
                id: 36,
                label: 'ApprovalsLevels',
                link: '/approvals/approval-levels',
                parentId: 34
            }
        ]
    },
    {
        id: 15,
        label: 'reports',
        icon: 'ph-file-text',
        subItems: [
            {
                id: 16,
                label: 'EmployeesReports',
                link: '/reports/employees-reports',
                parentId: 15
            },
            // {
            //     id: 17,
            //     label: 'attendanceReports',
            //     link: '/reports/checkin-reports',
            //     parentId: 15
            // },
            // {
            //     id: 18,
            //     label: 'equipmentsReports',
            //     link: '/reports/equipments-reports',
            //     parentId: 15
            // },
        ]
    },
    {
        id: 19,
        label: 'SystemAdministration',
        icon: 'ph-briefcase',
        subItems: [
            // {
            //     id: 20,
            //     label: 'users',
            //     link: '/administration/users',
            //     parentId: 19
            // },
            {
                id: 21,
                label: 'roles',
                link: '/administration/roles',
                parentId: 19
            },
            // {
            //     id: 22,
            //     label: 'permissions',
            //     link: '/administration/permissions',
            //     parentId: 19
            // },
            {
                id: 43,
                label: 'actions',
                link: '/administration/actions',
                parentId: 19
            },
            // {
            //     id: 23,
            //     label: 'lists',
            //     link: '/administration/lists',
            //     parentId: 19
            // },
            // {
            //     id: 24,
            //     label: 'departments',
            //     link: '/administration/departments',
            //     parentId: 19
            // },
        ]
    }
]